import PlainImage from './PlainImage';

export default PlainImage;
